import { Box } from '@modusign/design-system';
import { ReactNode } from 'react';

import TransformTextStyle from '@app/components/TextField/TransformTextStyle';

interface TextBaseFieldPlaceholderValueProps {
  transformTextStyle: Partial<TransformTextStyle>;
  value: ReactNode;
}

const defaultProps = {
  transformTextStyle: {},
  value: '텍스트',
};

function TextBaseFieldPlaceholderValue({
  transformTextStyle,
  value,
}: TextBaseFieldPlaceholderValueProps) {
  return (
    <Box
      style={transformTextStyle}
      sx={{
        letterSpacing: 'normal',
        lineHeight: 1,
        position: 'absolute',
        whiteSpace: 'nowrap',
        wordBreak: 'break-all',
      }}
    >
      {value}
    </Box>
  );
}

TextBaseFieldPlaceholderValue.defaultProps = defaultProps;

export default TextBaseFieldPlaceholderValue;
